import React from 'react';
import { cn } from '@/lib/utils';

/**
 * AhorroCifra — la cifra de ahorro (BRAND.md §1, manual §09).
 *
 * "La cifra de ahorro ($1,000) siempre lleva el degradado rojo→rosa. Es el
 * clímax visual de cada pantalla, el momento 'paga menos'."
 *
 * Existe como componente y no como un estilo suelto justamente para que esa
 * regla no se pierda: donde haya un ahorro, se usa esto.
 *
 * Sobre fondo rojo el degradado no se lee, así que ahí el manual manda ir de
 * blanco a rosa — para eso está `sobreFondoRojo`.
 */
export function AhorroCifra({
  /** Monto ya formateado, p. ej. "$1,000". */
  children,
  /** Sobre fondo rojo el acento va de blanco a rosa (regla del manual). */
  sobreFondoRojo = false,
  as: Tag = 'span',
  className = '',
  style = {},
  ...rest
}) {
  const gradiente = sobreFondoRojo
    ? 'linear-gradient(100deg, #FFFFFF, #F794B4)'
    : 'linear-gradient(100deg, #F52B16, #FA759F)';

  return (
    <Tag
      className={cn('font-display font-bold', className)}
      style={{
        backgroundImage: gradiente,
        WebkitBackgroundClip: 'text',
        backgroundClip: 'text',
        color: 'transparent',
        letterSpacing: '-0.02em',
        lineHeight: 1.05,
        ...style,
      }}
      {...rest}
    >
      {children}
    </Tag>
  );
}

export default AhorroCifra;
